var tvilum = tvilum || {};
( function () {
    'use strict';
    tvilum.init = function () {
        tvilum.logVitals();
        tvilum.navigation.init();
    };

    tvilum.logVitals = function () {
        if ( e4.settings.debug.logWebVitals === true ) {
            e4.require.js( e4.settings.require.webVitals, function () {
                window.webVitals = window.webVitals || {};
                console.warn( 'Logging Web Vitals' )
                window.webVitals.getCLS( console.log );
                window.webVitals.getFID( console.log );
                window.webVitals.getLCP( console.log );
                window.webVitals.getTTFB( console.log );
                window.webVitals.getFCP( console.log );
            } );
        }
    };
    tvilum.navigation = {
        init: function () {
            tvilum.navigation.inlineSearch();
        },
        inlineSearch: function () {
            jQuery( '.js-e-header' ).find( '.js-tvilum-inline-search-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var strQuery = jQuery( event.target ).find( '.js-e-search-input' ).val();
                if ( e4.util.hash.get( 'search' ) === undefined ) {
                    e4.util.hash.set( 'search' );
                    jQuery( '.js-e-search-modal' ).find( '.js-e-search-input' ).val( strQuery );
                }
            } );
        }
    };

    // ADD TO CART NUMBER INCREMENT
    if ( jQuery( '.js-custom-number-input' ).length === 1 ) {
        jQuery( '#plus-btn' ).click( function () {
            jQuery( '#qty_input' ).val( parseInt( jQuery( '#qty_input' ).val() ) + 1 );
        } );
        jQuery( '#minus-btn' ).click( function () {
            jQuery( '#qty_input' ).val( parseInt( jQuery( '#qty_input' ).val() ) - 1 );
            if ( jQuery( '#qty_input' ).val() == 0 ) {
                jQuery( '#qty_input' ).val( 1 );
            }

        } );
    }
}() );
